/**
 * Redirect Modal for Varaluz Home Links
 * Place this file in assets/redirect-modal.js
 */

let redirectUrl = '';

function showRedirectModal(url) {
    redirectUrl = url;
    const modal = document.getElementById('redirectModal');
    if (modal) {
        modal.classList.add('active');
        document.body.style.overflow = 'hidden';
    }
}

function closeRedirectModal() {
    const modal = document.getElementById('redirectModal');
    if (modal) {
        modal.classList.remove('active');
        document.body.style.overflow = '';
        redirectUrl = '';
    }
}

function proceedToRedirect() {
    if (redirectUrl) {
        window.open(redirectUrl, '_blank');
        closeRedirectModal();
    }
}

function initRedirectModal() {
    document.addEventListener('click', function(event) {
        const link = event.target.closest('a');
        
        if (link && link.href) {
            // Check for both varaluzhome.com and www.varaluzhome.com
            if (link.href.includes('varaluzhome.com')) {
                event.preventDefault();
                showRedirectModal(link.href);
                return false;
            }
        }
    });
    
    const modal = document.getElementById('redirectModal');
    if (modal) {
        modal.addEventListener('click', function(event) {
            if (event.target === this) {
                closeRedirectModal();
            }
        });
    }
    
    document.addEventListener('keydown', function(event) {
        if (event.key === 'Escape') {
            closeRedirectModal();
        }
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initRedirectModal);
} else {
    initRedirectModal();
}

if (typeof Shopify !== 'undefined' && Shopify.theme) {
    document.addEventListener('shopify:section:load', initRedirectModal);
    document.addEventListener('shopify:section:reorder', initRedirectModal);
}